(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .controller('grcActionPlanFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'notificationService', 'grcActionPlanService', 'recomService', 'modalService', '$modal'];

    function Controller($rootScope, $scope, $state, notificationService, grcActionPlanService, recomService, modalService, $modal) {

        $scope.ctrlCtxt = {
            isDirty: false
        };

        $scope.actionPlan = $scope.boxModel;
        $scope.recommendation = $scope.boxContext.Recommendation;

        // Get Lookups
        $scope.allActionPlanTags = [];
        recomService.getLookups()
                    .then(function (lkups) {
                        $scope.lookups = lkups;

                        if (!$scope.recommendation) return;
                        $scope.allActionPlanTags = $scope.lookups.RecomActionPlanTags[$scope.recommendation.RecomBusinessUnitID];
                        setAvailableActionPlanTags();
                    });

        function setAvailableActionPlanTags() {

            $scope.availableActionPlanTags = _.differenceWith(
                                                $scope.allActionPlanTags,
                                                $scope.actionPlan.RecomActionPlanTagList,
                                                function (tag, selected) {
                                                    return tag.LookupAttributeValueID === selected.LookupAttributeValueID;
                                                });
        }

        // On Action Plan Tag List Change
        $scope.onActionPlanTagListChange = function () {
            setAvailableActionPlanTags();
            $scope.pageIsDirty();
        };

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.isDirty = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        // Page is not dirty
        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.isDirty = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Show Reset Action?
        $scope.showResetAction = function () {
            return $scope.ctrlCtxt.isDirty;
        };

        // Edit Model Part
        $scope.editModelPart = function (partName) {

            if (!$scope.actionPlan.HasActionPlan_Edit) return;

            // Modal to show
            var modalScope = $scope.$new(true);
            modalScope.actionPlan = _.cloneDeep($scope.actionPlan);

            var showModal = $modal({
                scope: modalScope,
                template: '/app/shared/grc/actionPlan/grcActionPlanEdit.' + partName + '.modal.tpl.html',
                placement: 'center'
            });

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
                $scope.pageIsNotDirty();
            };

            // On Save
            modalScope.onSave = function () {
                modalScope.close();
                notificationService.notify('Your changes have been saved');
                $scope.pageIsNotDirty();
                $state.reload();
            };

        };

        // Show Delete Action?
        $scope.showDeleteAction = function (form) {
            if (!_.isUndefined($scope.actionPlan.ActionPlanID) && $scope.actionPlan.HasActionPlan_Delete) {
                 return true;
            };
        };

        // Select Owner
        $scope.selectOwner = function (person) {
            $scope.actionPlan.Owner = person;
            $scope.actionPlan.OwnerID = person.ItemPersonID;
            $scope.pageIsDirty();
        }
        // Select Owner Delegate
        $scope.selectOwnerDelegate = function (person) {
            $scope.actionPlan.OwnerDelegate = person;
            $scope.actionPlan.OwnerDelegateID = person.ItemPersonID;
            $scope.pageIsDirty();
        };

        // Show Save Action?
        $scope.showSaveAction = function (form) {
            if (!$scope.actionPlan.ActionPlanID) return false;

            return $scope.showResetAction(form);
        };

        // Show Add Action?
        $scope.showAddAction = function (form) {
            if ($scope.actionPlan.ActionPlanID) return false;

            return !form.$invalid;
        };

        // Open Action Plan Comments Modal
        $scope.openActionPlanComments = function () {
            modalService.displayTemplateModal(
                'Action Plan Comments',
                require('./grcActionPlanComments.modal.tpl.html'),
                {
                    actionPlan: $scope.boxModel,
                    modernStyle: true,
                    ngStyle: {'overflow-x': 'hidden'}
                },
                false,
                true
            )
        };

        // Reset forms
        $scope.reset = function () {
            $state.reload();
        };

        // Create Action Plan
        $scope.createActionPlan = function () {

            grcActionPlanService
                .createActionPlan($scope.recommendation.RecommendationID,
                                  $scope.actionPlan)
                .then(function (addedActionPlan) {
                    notificationService.notify('Action Plan has been added');
                    $state.go('recommendation.edit.actionPlan.edit', {
                        RecommendationID: $scope.recommendation.RecommendationID,
                        ActionPlanID: addedActionPlan.ActionPlanID
                    });
                });
        };

        // Update Action Plan
        $scope.updateActionPlan = function () {

            grcActionPlanService
                .updateActionPlan($scope.actionPlan)
                .then(function () {
                    notificationService.notify('Your changes have been saved');
                    $state.reload();
                });
        };

        // Delete Action Plan
        $scope.deleteActionPlan = function () {

            grcActionPlanService
                .deleteActionPlan($scope.actionPlan)
                .then(function () {
                    $scope.clickToBack();
                });
        }
    }
})();
